import React from 'react'
import Link from "./Link";

export default function Product(props) {
    return (
        <Link to={"/product/" + props.id} className="product">
            <div>
                <div className="image-container">
                    <img
                        src={"http://cdn.ab.pl/img_cache.php?gid=" + props.id + "&iid=" + props.image_id + "&w=50&h=50"}/>
                </div>
                <div>{props.name}</div>
            </div>
        </Link>
    );
}